import { lazily } from 'react-lazily';

import { handleLoadError } from '@ll-platform/frontend/config/setupLoadErrorHandler';

export const lazyLoad = <T extends object>(
  loader: (x?: string | undefined) => Promise<T>,
) => {
  return lazily(async () => {
    try {
      return (await loader()) as T;
    } catch (error) {
      if (
        error &&
        error instanceof Error &&
        error.message.includes('Failed to fetch dynamically imported module')
      ) {
        handleLoadError();
      }

      throw error;
    }
  });
};
